import { render, staticRenderFns } from "./DoctorApp.vue?vue&type=template&id=001fec1e"
import script from "./DoctorApp.vue?vue&type=script&lang=js"
export * from "./DoctorApp.vue?vue&type=script&lang=js"
import style0 from "./DoctorApp.vue?vue&type=style&index=0&id=001fec1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports